<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vi"></a><a id="page_vii">Contents</a></h1><a id="page_vii">
<p class="image"><img alt="Image" src="images/line1.jpg"/></p>
</a><p class="toc-fm"><a id="page_vii"></a><a href="#/006_Introduction#fm-1">Introduction</a></p>
<p class="toc-chap"><a href="#/007_Chapter01#ch-1">1.<span class="toc">Intellectual Humility</span></a></p>
<p class="toc-chap"><span href="#/008_Chapter02#ch-2" title="Link target outside of Sample">2.<span class="toc">Conflict</span></span></p>
<p class="toc-chap"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="toc">Independence</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="toc">Dialogue</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="toc">Choosing a Model</span></span></p>
<p class="toc-bm"><span href="#/012_Conclusion#bm-1" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-bm1"><span href="#/013_Acknowledgment#bm-2" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc-bm"><a href="#/014_DiscussionQuestion#bm-3"><em>Discussion Questions</em></a></p>
<p class="toc-bm"><span href="#/015_Endnotes#bm-4" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-bm"><span href="#/016_References#bm-5" title="Link target outside of Sample"><em>References</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?72a097ba